(function () {
  const root = document.querySelector('.drc-survey');
  if (!root) return;

  // Hardcoded Apps Script web app (scriptId 10KUc8u_U_q-LRFs6acYxEG9FMUklBpgpgNIeWH_7GIwsNHNwbQuKRjwR)
  const ENDPOINT =
    'https://script.google.com/macros/s/AKfycbzDj20Upzy6EpIfgyrI0UZxwp9btbRl3pFMTlp86H7qFZMO4972feMO30YMAC9houk/exec';
  const SIGNUP_URL = root.getAttribute('data-signup-url') || '/account/register';
  const HOME_URL = root.getAttribute('data-home-url') || '/';
  const SHOW_DEBUG = root.getAttribute('data-show-debug') === 'true';

  const RATING_ROWS = [
    'Customer Service',
    'Technical Support',
    'Marketing Programs / Content',
    'Shipping Service',
    'Shipping Fee / Cost',
    'Stock Availability',
    'Pricing',
  ];
  const STEP_NAMES = [
    'Your email',
    'Your garage',
    'Hobby habits',
    'Help us improve',
    'Email preferences',
  ];
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const totalSteps = 5;

  const answers = { style: [], brands: [], content: [], priority: [], ratings: {} };
  let step = 1;
  let submitting = false;

  const bar = document.getElementById('bar');
  const car = document.getElementById('car');
  const stepName = document.getElementById('stepName');
  const stepCount = document.getElementById('stepCount');
  const backBtn = document.getElementById('backBtn');
  const nextBtn = document.getElementById('nextBtn');

  const REQUIRED = {
    1: [{ type: 'email', q: 'q-email' }],
    2: [
      { type: 'single', key: 'tenure', q: 'q-tenure' },
      { type: 'single', key: 'level', q: 'q-level' },
      { type: 'multi', key: 'style', q: 'q-style' },
    ],
    3: [
      { type: 'single', key: 'frequency', q: 'q-frequency' },
      { type: 'single', key: 'buyingStyle', q: 'q-buyingStyle' },
      { type: 'multi', key: 'priority', q: 'q-priority' },
    ],
    4: [
      { type: 'single', key: 'recommend', q: 'q-recommend' },
      { type: 'grid', q: 'q-ratings' },
    ],
    5: [
      { type: 'single', key: 'emailFreq', q: 'q-emailFreq' },
      { type: 'multi', key: 'content', q: 'q-content' },
    ],
  };

  const grid = document.getElementById('ratingGrid');
  RATING_ROWS.forEach(function (label) {
    const row = document.createElement('div');
    row.className = 'grid-row';
    const name = document.createElement('div');
    name.className = 'name';
    name.textContent = label;
    const rate = document.createElement('div');
    rate.className = 'rate';
    rate.dataset.rating = label;
    for (let i = 1; i <= 5; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = i;
      b.dataset.val = i;
      b.setAttribute('aria-pressed', 'false');
      rate.appendChild(b);
    }
    row.appendChild(name);
    row.appendChild(rate);
    grid.appendChild(row);
  });

  function clearErr(qEl) {
    if (!qEl) return;
    const e = qEl.querySelector('.q-error');
    if (e) e.hidden = true;
    qEl.classList.remove('invalid');
  }

  function setErr(id, on) {
    const q = document.getElementById(id);
    if (!q) return;
    const e = q.querySelector('.q-error');
    if (e) e.hidden = !on;
    q.classList.toggle('invalid', on);
  }

  function maybeToggleOther(key) {
    const map = {
      style: ['styleOtherWrap', 'styleOther'],
      brands: ['brandsOtherWrap', 'brandsOther'],
    };
    if (!map[key]) return;
    const wrap = document.getElementById(map[key][0]);
    const input = document.getElementById(map[key][1]);
    const on = (answers[key] || []).indexOf('Other') > -1;
    wrap.classList.toggle('show', on);
    if (on) {
      setTimeout(function () {
        input.focus();
      }, 70);
    } else {
      input.value = '';
    }
  }

  document.querySelectorAll('[data-single]').forEach(function (group) {
    const key = group.dataset.single;
    group.addEventListener('click', function (e) {
      const btn = e.target.closest('button');
      if (!btn) return;
      group.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
      answers[key] = btn.dataset.val;
      clearErr(group.closest('.q'));
    });
  });

  document.querySelectorAll('[data-multi]').forEach(function (group) {
    const key = group.dataset.multi;
    group.addEventListener('click', function (e) {
      const btn = e.target.closest('button');
      if (!btn) return;
      const on = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      const set = new Set(answers[key]);
      on ? set.delete(btn.dataset.val) : set.add(btn.dataset.val);
      answers[key] = Array.from(set);
      maybeToggleOther(key);
      clearErr(group.closest('.q'));
    });
  });

  grid.addEventListener('click', function (e) {
    const btn = e.target.closest('button');
    if (!btn) return;
    const rate = btn.closest('.rate');
    const label = rate.dataset.rating;
    rate.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    btn.setAttribute('aria-pressed', 'true');
    answers.ratings[label] = btn.dataset.val;
    clearErr(document.getElementById('q-ratings'));
  });

  document.getElementById('email').addEventListener('input', function () {
    clearErr(document.getElementById('q-email'));
  });

  function validateStep(n) {
    let firstBad = null;
    (REQUIRED[n] || []).forEach(function (c) {
      let ok = true;
      if (c.type === 'email') {
        ok = EMAIL_RE.test((document.getElementById('email').value || '').trim());
      } else if (c.type === 'single') {
        ok = !!answers[c.key];
      } else if (c.type === 'multi') {
        ok = Array.isArray(answers[c.key]) && answers[c.key].length > 0;
      } else if (c.type === 'grid') {
        ok = Object.keys(answers.ratings).length === RATING_ROWS.length;
      }
      setErr(c.q, !ok);
      if (!ok && !firstBad) firstBad = document.getElementById(c.q);
    });
    return firstBad;
  }

  function show(n) {
    document.querySelectorAll('.step').forEach(function (s) {
      s.classList.toggle('active', +s.dataset.step === n);
    });
    const pct = (n / totalSteps) * 100;
    bar.style.width = pct + '%';
    car.style.left = pct + '%';
    stepName.textContent = STEP_NAMES[n - 1];
    stepCount.textContent = n + ' / ' + totalSteps;
    backBtn.disabled = n === 1;
    nextBtn.textContent = n === totalSteps ? 'Submit survey' : 'Next';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  backBtn.addEventListener('click', function () {
    if (step > 1) {
      step--;
      show(step);
    }
  });

  nextBtn.addEventListener('click', function () {
    if (submitting) return;
    const bad = validateStep(step);
    if (bad) {
      bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const inp = bad.querySelector('input');
      if (inp) inp.focus();
      return;
    }
    if (step < totalSteps) {
      step++;
      show(step);
      return;
    }
    submit();
  });

  function withOther(arr, inputId) {
    arr = (arr || []).slice();
    const i = arr.indexOf('Other');
    if (i > -1) {
      const txt = (document.getElementById(inputId).value || '').trim();
      arr.splice(i, 1);
      arr.push(txt || 'Other');
    }
    return arr;
  }

  function buildPayload() {
    return {
      brand: 'Direct RC',
      source: 'directrc-survey',
      email: (document.getElementById('email').value || '').trim(),
      name: (document.getElementById('name').value || '').trim(),
      rc_tenure: answers.tenure || '',
      rc_experience: answers.level || '',
      rc_style: withOther(answers.style, 'styleOther'),
      rc_brands: withOther(answers.brands, 'brandsOther'),
      purchase_frequency: answers.frequency || '',
      monthly_spend: answers.spend || '',
      buying_style: answers.buyingStyle || '',
      shopping_priority: answers.priority || [],
      recommend_1to5: answers.recommend || '',
      satisfaction: answers.ratings || {},
      improvement_note: (document.getElementById('improve').value || '').trim(),
      email_frequency: answers.emailFreq || '',
      content_preferences: answers.content || [],
      submitted_at: new Date().toISOString(),
      pageUrl: window.location.href,
      userAgent: navigator.userAgent || '',
    };
  }

  function showResult(payload, syncMeta) {
    document.getElementById('survey').style.display = 'none';
    document.getElementById('doneEmail').textContent = payload.email || 'your inbox';
    const panel = document.getElementById('resultPanel');
    panel.style.display = 'block';
    const details = panel.querySelector('details');
    if (details) details.hidden = !SHOW_DEBUG;
    const resultJson = document.getElementById('resultJson');
    if (resultJson) {
      resultJson.textContent = JSON.stringify(
        { payload: payload, sync: syncMeta || null },
        null,
        2
      );
    }
    bar.style.width = '100%';
    car.style.left = '100%';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function syncToAppsScript(payload) {
    // Apps Script web apps redirect; opaque POST is the reliable browser path.
    return fetch(ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    }).then(function () {
      return { ok: true, opaque: true };
    });
  }

  function submit() {
    if (submitting) return;
    submitting = true;
    nextBtn.disabled = true;
    nextBtn.textContent = 'Submitting…';

    const payload = buildPayload();
    window.__surveyPayload = payload;

    syncToAppsScript(payload)
      .then(function (syncMeta) {
        showResult(payload, syncMeta);
      })
      .catch(function (err) {
        showResult(payload, {
          ok: false,
          error: err && err.message ? err.message : String(err),
        });
      })
      .finally(function () {
        submitting = false;
      });
  }

  const signupLink = document.getElementById('signupLink');
  const homeLink = document.getElementById('homeLink');
  if (signupLink) signupLink.href = SIGNUP_URL;
  if (homeLink) homeLink.href = HOME_URL;

  show(1);
})();
